/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";

const buttonstyle = (translateValue, buttonCss) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  margin: auto;
  ${translateValue && "transform: " + translateValue + ";"}
  ${buttonCss ? buttonCss : "font-size: medium;"}
  font-size: 14px;
  &:hover {
    cursor: pointer;
  }
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

const addIconStyle = (iconCss) => css`
  width: ${iconCss?.width ? iconCss?.width : "25px"};
  height: ${iconCss?.height ? iconCss?.height : "25px"};
  border-radius: 25px;
  border: 2px solid white;
  padding: ${iconCss?.padding ? iconCss?.padding : "5px"};
  margin-right: ${iconCss?.marginRight ? iconCss?.marginRight : "12px"};
  &:hover {
    background: grey;
  }
`;

const AddCircularIcon = ({
  translateValue,
  handleClick,
  buttonText,
  buttonCss,
  iconCss,
}) => {
  return (
    <>
      {buttonText && (
        <Box
          css={() => buttonstyle(translateValue, buttonCss)}
          onClick={handleClick}
        >
          <AddIcon css={() => addIconStyle(iconCss)}></AddIcon>
          <span style={{ fontSize: "14px" }}>{buttonText}</span>
        </Box>
      )}
    </>
  );
};

export default AddCircularIcon;
